module.exports = __webpack_public_path__ + "static/frontend-de722d687e0fd417d4ff49329de89efc.png";